import React from 'react';
import { Code2, Brain, Database, Sparkles } from 'lucide-react';

const CATEGORY_META = {
  ai: { Icon: Brain, accent: 'cyan' },
  data: { Icon: Database, accent: 'purple' },
  programming: { Icon: Code2, accent: 'orange' },
};

const Skills3D = ({ data }) => {
  return (
    <section id="skills" className="section-container skills-section">
      <div className="content-wrapper">
        <div className="section-header">
          <div className="section-label">
            <Sparkles size={18} />
            <span>Skills</span>
          </div>
        </div>

        <div className="skills-stack">
          {data.map((group) => {
            const meta = CATEGORY_META[group.category] || { Icon: Sparkles, accent: 'cyan' };
            const { Icon, accent } = meta;
            const allSkills = [...(group.core || []), ...(group.working || [])];

            return (
              <div className={`skills-row skills-row--${accent}`} key={group.category}>
                <div className="skills-row-header">
                  <div className="skills-row-icon">
                    <Icon size={24} />
                  </div>
                  <div className="skills-row-titles">
                    <h3 className="skills-row-title">{group.label}</h3>
                  </div>
                </div>

                <ul className="skills-chip-list">
                  {allSkills.map((name) => (
                    <li className="skills-chip" key={name}>{name}</li>
                  ))}
                </ul>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Skills3D;
